import "ress";

import { createGlobalStyle } from "styled-components";
import media from "styled-media-query";

import iconArrowDown from "./assets/icon-arrow-down.svg";

const GlobalStyle = createGlobalStyle`
  html, body, #root {
    font-family: 'Montserrat', sans-serif;
    overflow-x: hidden;
  }

  img {
    display: inline-block;
    max-width: 100%;
  }

  a {
    text-decoration: none;
    color: inherit;
  }

  .container {
    width: 100%;
    max-width: 1302px;
    ${media.lessThan('1024px')`
      max-width: 768px;
    `}
    margin-left: auto;
    margin-right: auto;
  }

  .input-group {
    position: relative;
    z-index: 1;
    width: 100%;

    .form-control {
      display: block;
      width: 100%;
      height: 48px;
      padding: 2px 28px;
      background: #FAFAFA;
      border: 1px solid #E5E5E5;
      border-radius: 8px;
      color: #808080;

      &::placeholder {
        color: #808080;
      }

      &.dropdown {
        background-image: url(${iconArrowDown});
        background-repeat: no-repeat;
        background-position: right 14px center;
        cursor: pointer;
      }
      option {
        color: #000;
      }
    }

    .custom-check {
      font-weight: 400;
      font-size: 12px;
      line-height: 15px;
      color: #fff;

      input[type="checkbox"] {
        display: none;

        &:checked + label::after {
          display: block;
        }
      }

      label {
        position: relative;
        padding-left: 18px;
        cursor: pointer;
      }

      label::before {
        content: '';
        position: absolute;
        z-index: 2;
        top: 0;
        left: 0;
        width: 12px;
        height: 12px;
        background: #fff;
        opacity: 0.2;
        border-radius: 4px;
      }

      label::after {
        content: '';
        display: none;
        position: absolute;
        z-index: 4;
        top: 0;
        left: 0;
        width: 12px;
        height: 12px;
        background: #fff;
        border-radius: 4px;
      }
    }

    .msg-error {
      display: none;
      padding: 0 2px;
      margin-top: 4px;
      font-size: 12px;
      color: #F44336;
    }

    &.has-error {
      .form-control {
        border-color: #F44336;
      }
      .msg-error {
        display: block;
      }
    }

    &:not(:first-child) {
      margin-top: 12px;
    }
  }

  .input-group-grid {
    display: flex;
    width: 100%;
    justify-content: stretch;
    align-items: center;
    gap: 20px;

    ${media.lessThan('768px')`
      flex-direction: column;
    `}

    .input-group:not(:first-child) {
      margin-top: 0;
    }

    &:not(:first-child) {
      margin-top: 12px;
    }
  }

  .input-action {
    display: flex;
    margin-top: 20px;
  }

  .border {
    border: 4px solid #FFFFFF;
    box-shadow: 0px 10px 0px #FFFFFF;
    ${media.lessThan('768px')`
      box-shadow: 0px 8px 0px #FFFFFF;
    `}
  }

  body {
    background-color: #144BC8;
  }
`;

export default GlobalStyle;
